export default __webpack_public_path__ + "static/media/WNo.5-0.4fc84d2c.jpg";